import { HASHTAG } from "../../../constants/urls";
import HashtagIcon from "../../../projectSpecificComponents/svgIcons/hashtag";

export const Sidebar = {
  addButton: { title: "ایجاد هشتگ" },
  menu: [{ title: "لیست هشتگ‌ها", SvgIcon: HashtagIcon, link: HASHTAG }]
};
